import { render, staticRenderFns } from "./GoodTableRowGroup.vue?vue&type=template&id=0fcabade&"
import script from "./GoodTableRowGroup.vue?vue&type=script&lang=js&"
export * from "./GoodTableRowGroup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports